import { appUrl, getLogoURL } from "./url-constants";

export const getOrganizationSchemaJson = () => {
    return JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Cars24 Australia",
        "url": `${appUrl()}/`,
        "logo": getLogoURL(),
        "description": "Cars24 Australia helps customers buy and sell used cars online with inspection, paperwork support and delivery/pickup options.",
        "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "tel:1800227724",
            "email": "hello.au@cars24.com",
            "contactType": "customer support",
            "areaServed": ["AU"]
        },
        "sameAs": [
            "https://www.facebook.com/CARS24Australia/",
            "https://www.instagram.com/cars24au/",
            "https://www.linkedin.com/company/cars24-australia/",
            "https://twitter.com/cars24au"
        ]
    });
};

